<template>
    <div class="bg-blur py-6 lg:py-12 -mx-4">
        <div class="container max-w-[800px] m-auto flex flex-col gap-6">
            <div>
                <div class="text-xl mb-1 text-headline font-semibold text-center">{{ title }}</div>
                <div class="text-lg text-center">{{ text }}</div>
            </div>
            
            <div class="flex flex-col lg:flex-row gap-2 lg:justify-center lg:items-center lg:px-4">
                <div class="flex gap-2 mx-auto lg:mx-0">
                    <template v-for="image in images" :key="image.mediaId">
                        <LazyLayoutImage
                            v-if="image?.media"
                            :media="image.media"
                            :preload="false"
                            class="w-[100px] h-[100px] object-cover rounded-full border-2 border-white flex-shrink-0"
                        />
                    </template>
                </div>
                <div>
                    <div class="text-headline text-2xl font-semibold flex flex-col lg:flex-row lg:gap-1 items-center">
                        <span>{{ t('layout.footer.phoneService.phoneNumberText') }}</span>
                        <div class="flex gap-1">
                            <span>{{ t('layout.footer.phoneService.phoneNumberLabel') }}</span>
                            <a :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a>
                        </div>
                    </div>
                    <div class="text-lg text-center lg:text-left">{{ openingHours }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type {HblMedia} from '@/utils/types'

const { t } = useI18n()

interface PhoneServiceImage {
    mediaId: string
    mediaUrl: string
    media?: HblMedia
}

const props = defineProps<{
    title: string
    text: string
    phoneNumber: string
    openingHours: string
    images?: PhoneServiceImage[]
}>()
</script>